
import Vue from 'vue'
import '@/assets/css/common.css';
import App from './App'
import router from './router'
import { get, post } from './httpConfig/http'
import './assets/css/common.css'
import waves from './util/directive/waves/WavesDirective'
import inputDirective from './util/directive/index'
// eslint-disable-next-line no-unused-vars
import sytfilter from './util/filter/Filter'
import * as font from '@/util/font'
import './util/auto_refresh'
import Vconsole from 'vconsole'
import './util/vant';
if (process.env.NODE_ENV != "prod" && process.env.NODE_ENV != "development") {
    let vConsole = new Vconsole()
    Vue.use(vConsole)
}
Vue.use(inputDirective)
Vue.use(waves)
font.setRem()
window.onresize = () => {
    font.setRem()
}

Vue.config.productionTip = false
Vue.$get = Vue.prototype.$get = get
Vue.$post = Vue.prototype.$post = post

router.beforeEach(async (to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js